// /assets/custom.js.liquid -->

// Yotpo reviews remove 'reviews'

const mutationTargets = document.querySelectorAll(".js-mutation-target");

const mutationObserver = new MutationObserver((mutationList) => {
  for (const mutation of mutationList) {
    const target = mutation.target;
    if (!target) return;

    if (mutation.type === "childList") {
      const text = target.querySelector("a[tabindex]");
      if (!text) return;
      const number = text.innerText.split(" ")[0];
      if (!number) return;
      text.innerText = number;
      text.classList.add("updated");
    }
  }
});

mutationTargets.forEach((target) => {
  mutationObserver.observe(target, { childList: true, subtree: true });
});

// Calculate header height
const header = document.querySelector(".js-site-header");

if (header) {
  header.style.setProperty(
    "--header-height",
    header.getBoundingClientRect().height + "px"
  );

  document.body.style.setProperty(
    "--header-height",
    header.getBoundingClientRect().height + "px"
  );

  window.addEventListener("resize", () => {
    header.style.setProperty(
      "--header-height",
      header.getBoundingClientRect().height + "px"
    );

    document.body.style.setProperty(
      "--header-height",
      header.getBoundingClientRect().height + "px"
    );
  });
}

function addToCart(id, quantity, callback) {
  const cartAddUrl = window.cartAddUrl + ".js";
  const body = { items: [{ id, quantity }] };

  return fetch(cartAddUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((error) => console.error(error));
}

function ready(fn) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

ready(function () {
  console.log("/assets/custom.js.liquid ready===============");
  const $ = jQuery;

  const moveSocialMediaIcons = () => {
    // Copy + append element #sm-icons (Social Icons) to ul.mobile-nav:last-of-type() (Mobile Nav)
    const smIcons = document.getElementById("sm-icons");
    const smIconsClone = smIcons.cloneNode(true);
    const wrapper = document.createElement("li");
    wrapper.classList.add("header-social-icons");
    wrapper.appendChild(smIconsClone);
    document.querySelector("ul.mobile-nav:last-child").append(wrapper);
  };

  const createSplideCarousel = () => {
    const elms = document.getElementsByClassName("splide");

    for (var i = 0; i < elms.length; i++) {
      new Splide(elms[i]).mount();
    }
  };

  const productTabs = () => {
    const productTabs = $(".product-tabs");
    const mobileProductTabs = $(".product-tabs--mobile");

    productTabs.on("click", ".tab", function (e) {
      const tabIndex = $(e.target).attr("href");
      const tabContainer = e.delegateTarget;
      const tabNavs = $(tabContainer).find(".tab-nav .tab");
      const tabPanes = $(tabContainer).find(".tab-content > div");

      tabNavs.removeClass("active");
      $(this).addClass("active");

      e.preventDefault();
      tabPanes.hide();
      tabPanes.removeClass("active");
      for (i = 0; i < tabPanes.length; i++) {
        if ($(tabPanes).eq(i).is(tabIndex)) {
          $(tabPanes).eq(i).show();
          $(tabPanes).eq(i).addClass("active");
        }
      }
    });

    mobileProductTabs.on("click", ".tab > a", function (e) {
      e.preventDefault();
      const currentTab = $(this).parent(".tab");
      currentTab.find(".tab-content").slideToggle(function () {
        if ($(this).is(":visible")) {
          $(this).parent(".tab").addClass("active");
        } else {
          $(this).parent(".tab").removeClass("active");
        }
      });
    });
  };

  const initReadMore = () => {
    const descriptionTab = $(".description-tab--content");
    const maxHeight = 800;

    const origHeight = $(descriptionTab).height();

    if ($(descriptionTab).height() >= maxHeight) {
      descriptionTab.addClass("has-more");
      descriptionTab.attr("data-original-height", origHeight);
      descriptionTab.after('<div class="read-more--toggle">Read More...</div>');
    }

    $(document).on("click", ".read-more--toggle", function () {
      const maxHeight = 500;
      const content = $(this).prev(".description-tab--content");
      const origHeight = content.data("original-height");
      console.log(content.height());
      if (content.height() == origHeight) {
        content.animate(
          {
            height: maxHeight,
          },
          500
        );
        $(".read-more--toggle").text("Read More...");
      } else {
        content.animate(
          {
            height: origHeight,
          },
          500
        );
        $(".read-more--toggle").text("Read Less...");
      }
    });
  };

  const rechargeSelectors = () => {
    setTimeout(function () {
      console.log("rechargeSelectors");
      $("label.onetime-radio span.rc-radio__label").text("One-Time Purchase");
      $(".rc-selling-plans").appendTo("label.subscription-radio");
    }, 3800);
  };

  const navigationUx = () => {
    const menuImage = $(".mega-menu--image"),
      navContainer = $("header.site-header .custom-mega-menu");
    $(document).on(
      "mouseover",
      "ul.mega-menu-wrapper > li.site-nav--has-dropdown.mega-menu",
      function () {
        if (!$(this).hasClass("shop-all")) {
          menuImage.hide();
          navContainer.css("height", "300px");
        } else {
          menuImage.show();
          navContainer.css("height", "490px");
        }
      }
    );
    $(document).on(
      "mouseover",
      "li.site-nav--has-dropdown.mega-menu.shop-all",
      function () {
        menuImage.show();
        navContainer.css("height", "490px");
      }
    );
    $(document).on(
      "mouseover",
      "li.site-nav--has-dropdown.mega-menu.diets-&-programs",
      function () {
        menuImage.hide();
        navContainer.css("height", "300px");
      }
    );
    $(document).on(
      "mouseover",
      "li.site-nav--has-dropdown.mega-menu.discover",
      function () {
        menuImage.hide();
        navContainer.css("height", "300px");
      }
    );
  };

  const guaranteePopup = () => {
    const $guaranteeBtn = $(".product__new_packing_details");

    $guaranteeBtn.on("click", function (e) {
      e.preventDefault();
      $(".product-guarantee-popup.modal-overlay").fadeIn();
    });

    // When the X button is clicked
    $(".product-guarantee-popup .modal-close-btn").on("click", function (e) {
      // Hide the modal
      $(".product-guarantee-popup.modal-overlay").fadeOut();
    });
  }

  function getCookie(name) {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
  }

  function updateAnnouncementBar() {
    const discountCodeCookie = getCookie('discount_code');
    const announcementBarMessage = document.querySelector('.swiper-slide-active .announcement-bar--message-inner');

    if (discountCodeCookie && discountCodeCookie) {
      announcementBarMessage.innerHTML = `Code: ${discountCodeCookie} applied at checkout`;
    }
  }

    function mobileNavScroll(){
    if (window.innerWidth <= 766) {
      const headerElement = document.querySelector('#shopify-section-header');
      const scrollThreshold = 44;
      let lastScrollY = window.scrollY;

      function togglePositionFixed() {
        if (window.scrollY > lastScrollY && window.scrollY >= scrollThreshold) {
          headerElement.classList.add('position-fixed');
        } else {
          headerElement.classList.remove('position-fixed');
        }
        lastScrollY = window.scrollY;
      }

      window.addEventListener('scroll', togglePositionFixed);
    }
  }

  mobileNavScroll();
  updateAnnouncementBar();
  moveSocialMediaIcons();
  createSplideCarousel();
  productTabs();
  initReadMore();
  // navigationUx();
  rechargeSelectors();
  guaranteePopup();
});
